import { DOCUMENTS_TAGS } from "constants/constants";

export const documentGetterInfos = {
  [DOCUMENTS_TAGS.TAG_DAV_WLC_LETTER]: {
    fileName: "welcome_letter.docx",
    type: "welcome_letter",
  },
  [DOCUMENTS_TAGS.TAG_DAV_EMPL_CERT]: {
    fileName: "employee_certificate.docx",
    type: "employee_certificate",
  },
  [DOCUMENTS_TAGS.TAG_DAV_INS_CERT]: {
    fileName: "health_insurance.docx",
    type: "health_insurance",
  },
  [DOCUMENTS_TAGS.TAG_MISSION_ORDER]: {
    fileName: "mission_order.docx",
    fileNamePDF: "mission_order.pdf",
    type: "mission_order",
  },
  [DOCUMENTS_TAGS.TAG_SERVICE_CONTRACT]: {
    fileName: "service_contract.docx",
    fileNamePDF: "service_contract.pdf",
    type: "service_contract",
  },
  [DOCUMENTS_TAGS.TAG_DAV_TEST_PERIOD]: {
    fileName: "trial_period.docx",
    type: "test_period_renewal",
  },
  [DOCUMENTS_TAGS.TAG_DAV_NON_COMP]: {
    fileName: "non_compete_clause.docx",
    type: "non_compete_clause",
  },
  [DOCUMENTS_TAGS.TAG_LIAISON_MAIL]: {
    fileName: "liaison_mail.docx",
    type: "liaison_mail",
  },
};
